import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isNode from 'tests/isNode';
import videojs from 'video.js';

const TESTING = isNode();
// Don't require techs if in testing environment
if (!TESTING){
	require('videojs-youtube');
	require('utils/videojs-vimeo');
}

export class VjsVideo extends Component{

	static propTypes = {
		onPlayerEnded: PropTypes.func,
		onPlayerReady: PropTypes.func,
		onPlayerPlay: PropTypes.func,
		onPlayerPaused: PropTypes.func,
		onPlayerLoadedMetadata: PropTypes.func,
		aspect: PropTypes.number
	};

	static defaultProps = {
		aspect: 16/9
	};
	
	constructor(props){
		super(props);
	}

	componentDidMount(){
		const self = this;
		let {
			aspect,
			onPlayerEnded,
			onPlayerReady,
			onPlayerPlay,
			onPlayerPaused,
			onPlayerLoadedMetadata,
			...vjsProps
		} = this.props;
		if (!TESTING){
			this.playerElement = videojs(
				this.videoNode,
				vjsProps,
				function(){
					self.player = this;
					if (typeof onPlayerReady === 'function'){
						onPlayerReady();
					}
					self.player.on('ended', function(){
						if (typeof onPlayerEnded === 'function'){
							onPlayerEnded();
						}
					})
					self.player.on("pause", function(){
						if (typeof onPlayerPaused === 'function'){
							onPlayerPaused();
						}
					})
					self.player.on("play", function(){
						if (typeof onPlayerPlay === 'function'){
							onPlayerPlay();
						}
					})
					self.player.on("loadedmetadata", function(...args){
						if (typeof onPlayerLoadedMetadata === 'function'){
							onPlayerLoadedMetadata(...args);
						}
					})
				}
			)
		}
	}

	elementReady = videoNode => {
		this.videoNode = videoNode;
	}

	render(){
		let {aspect} = this.props;

		return (
			<div style={{
				width: "100%",
				height: 0,
				position: "relative",
				display: "block",
				paddingBottom: `${(1 / aspect) * 100}%`
			}}>
				<video
					ref={this.elementReady}
					className="video-js"
					style={{
						position: "absolute",
						top: 0,
						bottom: 0,
						left: 0,
						right: 0,
						width: "100%",
						height: "100%"
					}}
				></video>
			</div>
		);
	}
}
export default VjsVideo;
